import { createFileRoute } from '@tanstack/react-router'
import { MeetingJoinPage } from '@/components/meeting/join-page'
export const Route = createFileRoute('/meeting/join/$token')({ component: MeetingJoinPage })
